<div class="list-item" [ngClass]="{'big': item?.attributes?.big_image}" (click)="open()" *ngIf="language">
  <div class="list-item__details">
    <div class="title-holder" [innerHTML]="item?.attributes?.title"></div>
    <span class="list-item__details-date"> {{ item?.attributes?.publish_date | dateTranslate:'shortDate':language }} </span>
  </div>
  <div class="list-item__logo" *ngIf="item?.attributes?.image">
    <img [src]="item?.attributes?.image" />
    <div class="campaign-liked" *ngIf="item?.attributes?.liked && !isCampaignUpdate">
      <ion-icon name="heart"></ion-icon>
    </div>
    <div class="campaign-badge" [ngClass]="{small: !language.includes('en')}" *ngIf="isActive">
      {{'IMPACT.publicisCampaign.counter.title' | translate}}
    </div>
    <div class="campaign-update-badge" [ngClass]="{small: !language.includes('en')}" *ngIf="isCampaignUpdate">
      <p>{{'IMPACT.publicisCampaign.counter.title' | translate}}</p>
      <span>{{ 'IMPACT.publicisCampaignUpdate.engagement' | translate}}</span>
    </div>
  </div>
</div>
